var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Cập nhật thêm thông tin",
            "before-close": _vm.handleClose,
            visible: _vm.isOpenUpdateAccountBankDialog,
            "show-close": true,
            "close-on-click-modal": false,
            width: "700px",
            top: "20vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpenUpdateAccountBankDialog = $event
            },
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                "label-width": "260px",
                model: _vm.formData,
                "label-position": "left",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Thứ tự ưu tiên", prop: "priority" } },
                [
                  _vm.bank.authenticationOTP === true &&
                  _vm.bank.bankApiConnected === true
                    ? _c("el-input-number", {
                        staticStyle: { width: "200px" },
                        attrs: { min: 1 },
                        model: {
                          value: _vm.formData.priority,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "priority", $$v)
                          },
                          expression: "formData.priority",
                        },
                      })
                    : _c("el-input-number", {
                        staticStyle: { width: "200px" },
                        attrs: { min: 2 },
                        model: {
                          value: _vm.formData.priority,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "priority", $$v)
                          },
                          expression: "formData.priority",
                        },
                      }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Giới hạn hạn mức nhận vào trong tháng",
                    prop: "limit",
                  },
                },
                [
                  _c("el-checkbox", {
                    model: {
                      value: _vm.formData.limit,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "limit", $$v)
                      },
                      expression: "formData.limit",
                    },
                  }),
                ],
                1
              ),
              _vm.formData.limit === true
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Hạn mức nhận vào trong tháng",
                        prop: "moneyLimit",
                      },
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "200px" },
                        attrs: { min: 1 },
                        model: {
                          value: _vm.formData.moneyLimit,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "moneyLimit", $$v)
                          },
                          expression: "formData.moneyLimit",
                        },
                      }),
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatCurrency")(_vm.formData.moneyLimit)
                          )
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "success",
                    size: "medium",
                    loading: _vm.loading.submit,
                    mini: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _c("span", [_vm._v("Cập nhật")]),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "medium" },
                  on: { click: _vm.handleClose },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _c("span", [_vm._v("Đóng")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }